import config from '@/config'
import { requests } from './BaseService'

export const CalendarUserSettings = {
  getUserSettings: (locationId: string, userId: string) =>
    requests().get(
      `${config.calendarApiUrl}/calendars/user-settings/${locationId}/${userId}/features`
    ),
  updateUserSettingsFeatures: (data: any) =>
    requests().post(
      `${config.calendarApiUrl}/calendars/user-settings/features`,
      data
    ),
}
